module.exports = __webpack_public_path__ + "img/banner-notice.c401239a.png";